var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            { attrs: { size: "small", "label-position": "top" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("routes.departureTransferCenter"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value:
                                  _vm.queryForm.params.departTransferCenterId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "departTransferCenterId",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.departTransferCenterId",
                              },
                            },
                            _vm._l(_vm.flowDirectNextList, function (item) {
                              return _c("el-option", {
                                key: item.siteId,
                                attrs: {
                                  label: item.siteName,
                                  value: item.siteId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("routes.下一站流向") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.nextSiteId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "nextSiteId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.nextSiteId",
                              },
                            },
                            _vm._l(_vm.flowDirectNextList, function (item) {
                              return _c("el-option", {
                                key: item.siteId,
                                attrs: {
                                  label: item.siteName,
                                  value: item.siteId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("routes.发车时间") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              format:
                                _vm.$i18n.locale === "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.getTableData },
                          },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.search")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", plain: "" },
                            on: { click: _vm.resetSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")))]
                        ),
                        _c(
                          "el-radio-group",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { size: "small" },
                            on: {
                              change: function ($event) {
                                return _vm.getTableData()
                              },
                            },
                            model: {
                              value: _vm.queryForm.params.formalOrTest,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "formalOrTest",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.formalOrTest",
                            },
                          },
                          [
                            _c("el-radio-button", { attrs: { label: 1 } }, [
                              _vm._v(_vm._s(_vm.$t("newOrder.Formal"))),
                            ]),
                            _c("el-radio-button", { attrs: { label: 2 } }, [
                              _vm._v(_vm._s(_vm.$t("newOrder.test1"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.exportData },
              },
              [_vm._v(_vm._s(_vm.$t("collectionCenter.export")))]
            ),
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  "header-cell-style": {
                    background: "#f2f2f2",
                    color: "black",
                    textAlign: "center",
                  },
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    type: "selection",
                    width: "50",
                    fixed: "left",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("GlobalSetObj.serial"),
                    align: "center",
                    type: "index",
                    width: "80",
                    fixed: "left",
                  },
                }),
                _vm._l(_vm.tableColumn, function (item, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      label: item.label,
                      prop: item.prop,
                      align: item.align,
                      "min-width": item.width,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              item.prop === "bagQuantity"
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          color:
                                            scope.row["bagQuantity"] <
                                            scope.row["shouldBagQuantity"]
                                              ? "red"
                                              : "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row[item.prop]) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : item.prop === "normalQuantity"
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          color:
                                            scope.row["normalQuantity"] <
                                            scope.row["shouldNormalQuantity"]
                                              ? "red"
                                              : "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row[item.prop]) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : item.prop === "bigPieceQuantity"
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          color:
                                            scope.row["bigPieceQuantity"] <
                                            scope.row["shouldBigPieceQuantity"]
                                              ? "red"
                                              : "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row[item.prop]) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      " " + _vm._s(scope.row[item.prop]) + " "
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("GlobalSetObj.operate"),
                    align: "center",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("GlobalSetObj.details"),
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openAddEditWindow(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-document",
                                    staticStyle: { "font-size": "20px" },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              2
            ),
            _c("el-pagination", {
              staticStyle: { margin: "20px 0", "text-align": "right" },
              attrs: {
                "current-page": _vm.queryForm.pageNumber,
                "page-size": _vm.queryForm.pageSize,
                "page-sizes": [10, 50, 100, 200, 400],
                total: _vm.total,
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageNumber", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageNumber", $event)
                },
                "update:pageSize": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageSize", $event)
                },
                "update:page-size": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageSize", $event)
                },
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("GlobalSetObj.SenderDetails"),
            visible: _vm.isAddEditWindow,
            direction: "ltr",
            size: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isAddEditWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "calc(100vh - 130px)",
                "overflow-y": "auto",
              },
            },
            [
              _c("addEdit", {
                key: _vm.isAddEditWindow,
                ref: "addEditWindow",
                attrs: { "edit-row": _vm.editRow },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "right",
                padding: "10px",
                "border-top": "1px solid #ccc",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.isAddEditWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }